var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "c-order-totals u-margin-bottom-large" }, [
    _c("tr", [
      _c(
        "th",
        {
          staticClass: "t-heading-9 u-text-align-left",
          attrs: { scope: "row" }
        },
        [_vm._v("\n      Subtotal\n    ")]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "c-order-totals__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.subtotal) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("tr", { staticClass: "c-order-totals__tax" }, [
      _c(
        "th",
        {
          staticClass: "c-order-totals__indent t-heading-9 u-text-align-left",
          attrs: { scope: "row" }
        },
        [_vm._v("\n      Taxes\n    ")]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "c-order-totals__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.tax) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("tr", { staticClass: "c-order-totals__shipping" }, [
      _c(
        "th",
        {
          staticClass: "c-order-totals__indent t-heading-9 u-text-align-left",
          attrs: { scope: "row" }
        },
        [_vm._v("\n      Shipping\n    ")]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "c-order-totals__cell" }, [
        _vm._v("\n      " + _vm._s(_vm.shipping) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _vm.discounts
      ? _c("tr", { staticClass: "c-order-totals__discount" }, [
          _c(
            "th",
            {
              staticClass:
                "c-order-totals__discount-line c-order-totals__indent u-text-align-left t-heading-9",
              attrs: { scope: "row" }
            },
            [_vm._v("\n      Discounts\n    ")]
          ),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass: "c-order-totals__cell c-order-totals__discount-line"
            },
            [_vm._v("\n      -" + _vm._s(_vm.discounts) + "\n    ")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("tr", { staticClass: "c-order-totals__total u-margin-bottom-x-small" }, [
      _c(
        "th",
        {
          staticClass: "u-text-align-left t-heading-6",
          attrs: { scope: "row" }
        },
        [_vm._v("\n      Total\n    ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "c-order-totals__cell c-order-totals__bottom-line" },
        [_vm._v("\n      " + _vm._s(_vm.price) + "\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }